import React, { Component } from "react";
import { Modal, Button } from 'react-bootstrap'
import { strings } from 'constants/strings';
import { linkProvider } from 'helpers/linkProvider'
//To do Links

//let googleImage = '/images/badges/google/' + strings.Web_Dashboard_Googlebtn
let googleImage = '/react/images/badges/google/' + strings.Web_Dashboard_Googlebtn //To Do
//let amazonImage = '/images/amazonBtn/' + strings.Web_Dashboard_Amazonbtn
let amazonImage = '/react/images/badges/amazon/' + strings.Web_Dashboard_Amazonbtn
let appleImage = '/react/images/badges/apple/' + strings.Web_Dashboard_Applebtn
const HOST_NAME = window.location.hostname;

export class ModalBadges extends Component {
  render() {
    //    <a href="#"><img className="last-img-wrapper-popup" width='200px' src={comingSoonImg} alt="" /></a>  
    if (HOST_NAME.includes('speed')) {
      return (
        <>
        <a className={this.props.amazonBtnClass} target="_blank" rel="noopener" href={linkProvider.links.amazonModal}><img width='200px' src={amazonImage} alt="" /></a>
        </>
      )
    } else {
      return (
        <>
        <a className={this.props.googleBtnClass + " google-badge"} target="_blank" rel="noopener" href={linkProvider.links.googleApplePopUp}><img width='200px' src={googleImage} alt="" /></a>
        <a className={this.props.amazonBtnClass  + " amazon-badge"}  target="_blank" rel="noopener" href={linkProvider.links.amazonModal}><img width='200px' src={amazonImage} alt="" /></a>
        <a className={this.props.appleBtnClass + " apple-badge"}  target="_blank" rel="noopener" href={linkProvider.links.googleApplePopUp}><img width={221} height={65} src={appleImage} /></a>
        </>
      )
    }    
  }
}

export class PostExerciseBadges extends Component {
  render() {
    if (HOST_NAME.includes('speed')) {
      return (
        <div className="row download-button">
          <a
            id={this.props.btnAmazonId}
            className="col-sm-5 reg-btn"
            target="_blank" rel="noopener"
            style={{ padding: "0" }}
            href={linkProvider.links.amazonPostExercise}
          >
            <img style={{height: '55px'}} src={amazonImage} />
          </a>
        </div>
      )
    } else {
      return (
        <>
          <div className="download-button">
            <a
              id={this.props.btnAmazonId}
              className="reg-btn amazon-badge"
              target="_blank" rel="noopener"
              href={linkProvider.links.amazonPostExercise}
            >
              <img src={amazonImage} />
            </a>
            <a
              id={this.props.btnGoogleId}
              className="reg-btn google-badge"
              target="_blank" rel="noopener"
              href={linkProvider.links.googleApplePostExercise}
            >
              <img src={googleImage} />
            </a>
            <a 
              id={this.props.btnAppleId}
              className="reg-btn apple-badge"
              target="_blank" rel="noopener" 
              href={linkProvider.links.googleApplePostExercise}>
              <img className='budges-image' width={221} height={65} src={appleImage} />
            </a>
          </div>
        </>
      )
    }
  }
}

export class OtherBadges extends Component {
  render() {
    if (HOST_NAME.includes('speed')) {
      return (
        <a id="amazon-dashboard" target="_blank" rel="noopener" href={linkProvider.links.amazonDashboard}><img width={221} height={65} src={amazonImage} /></a>
      )
    } else {
      return (
        <>
          <a id="google-dashboard" className="google-badge" target="_blank" rel="noopener" href={linkProvider.links.googleAppleDashboard}><img className='budges-image' width={221} height={65} src={googleImage} /></a>
          <a id="amazon-dashboard" className="amazon-badge" target="_blank" rel="noopener" href={linkProvider.links.amazonDashboard}><img className='budges-image' width={221} height={65} src={amazonImage} /></a>
          <a id="apple-dashboard" className="apple-badge" target="_blank" rel="noopener" href={linkProvider.links.googleAppleDashboard}><img className='budges-image' width={221} height={65} src={appleImage} /></a>
        </>
      )
    }    
  }
}

export class ComingSoonBadges extends Component {
  render() {
    if (HOST_NAME.includes('speed')) {
      return (
        <a id="amazon-dashboard" target="_blank" rel="noopener" href={linkProvider.links.amazonModal}><img width={221} height={65} src={amazonImage} /></a>
      )
    } else {
      return (
        <>
          <a id="google-coming-soon" className="google-badge" target="_blank" rel="noopener" href={linkProvider.links.googleAppStore}><img className='budges-image' width={221} height={65} src={googleImage} /></a>
          <a id="amazon-coming-soon" className="amazon-badge" target="_blank" rel="noopener" href={linkProvider.links.amazonAppStore}><img className='budges-image' width={221} height={65} src={amazonImage} /></a>
          <a id="apple-coming-soon" className="apple-badge" target="_blank" rel="noopener" href={linkProvider.links.appleAppStore}><img className='budges-image' width={221} height={65} src={appleImage} /></a>
        </>
      )
    }    
  }
}